import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from '../components/Theme';
import { H1 } from 'UIComponents/elements/headings';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { useMediaQuery } from '../utils/hooks';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import PrerenderTags from '../components/Prerender'; // @ts-expect-error cannot find module

import directoryOpengraphSrc from 'bender-url!../../img/directory-opengraph.png';
import DirectoryFilters from '../features/directory/components/DirectoryFilters';
import FilterTags from '../features/directory/components/FilterTags';
import SortResultsBar from '../features/directory/components/SortResultsBar';
import UsersSearchGrid from '../features/directory/components/UsersSearchGrid';
import DirectoryPaginator from '../features/directory/components/DirectoryPaginator';
import DirectorySearchInput from '../features/directory/components/DirectorySearchInput';

const FilterToggleButton = ({
  isToggled,
  onToggle
}) => {
  return /*#__PURE__*/_jsxs(UIButton, {
    use: "transparent",
    responsive: false,
    onClick: onToggle,
    style: {
      paddingLeft: 0,
      paddingRight: 0
    },
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "filter"
    }), isToggled ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connectDotCom.hideFilters"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connectDotCom.showFilters"
    })]
  });
};

const Directory = () => {
  const screenLarge = useMediaQuery(`(min-width: ${GRID_BREAKPOINT_SMALL})`);
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const PageHeader = styled(H1).withConfig({
    displayName: "Directory__PageHeader",
    componentId: "sc-6dm8po-0"
  })(["font-size:", ";font-weight:400;"], props => props.theme.sizes.HEADING2);

  const handlePageChange = () => {
    window.scrollTo(0, 0);
  };

  return /*#__PURE__*/_jsxs("article", {
    "data-test-id": "directory-page",
    children: [/*#__PURE__*/_jsx(PrerenderTags, {
      title: I18n.text('connectDotCom.directory.seoTitle'),
      description: I18n.text('connectDotCom.directory.seoDescription'),
      image: directoryOpengraphSrc
    }), /*#__PURE__*/_jsxs(UIGrid, {
      children: [/*#__PURE__*/_jsxs(UIGridItem, {
        size: {
          md: 3,
          sm: 12,
          xs: 12
        },
        children: [/*#__PURE__*/_jsx(PageHeader, {
          className: "m-bottom-6",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "connectDotCom.directory.title"
          })
        }), !screenLarge && /*#__PURE__*/_jsx(FilterToggleButton, {
          onToggle: () => setFiltersExpanded(bool => !bool),
          isToggled: filtersExpanded
        }), /*#__PURE__*/_jsx(AccordionTransition, {
          duration: parseInt(MICRO_TRANSITION_TIMING, 10),
          open: screenLarge || filtersExpanded,
          children: /*#__PURE__*/_jsx(DirectoryFilters, {})
        })]
      }), /*#__PURE__*/_jsxs(UIGridItem, {
        size: {
          md: 9,
          sm: 12,
          xs: 12
        },
        children: [/*#__PURE__*/_jsx(DirectorySearchInput, {
          className: screenLarge ? 'm-top-0' : 'm-top-2'
        }), /*#__PURE__*/_jsx(SortResultsBar, {}), /*#__PURE__*/_jsx(FilterTags, {}), /*#__PURE__*/_jsx(UsersSearchGrid, {}), /*#__PURE__*/_jsx(DirectoryPaginator, {
          onPageChange: handlePageChange
        })]
      })]
    })]
  });
};

export default Directory;